'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDUCED_THRESHOLD = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _Legend = require('./Legend');

var _Legend2 = _interopRequireDefault(_Legend);

var _constants = require('../../../rules/src/constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REDUCED_THRESHOLD = exports.REDUCED_THRESHOLD = 160;

var scatterRenderer = function scatterRenderer(_ref) {
  var color = _ref.color;
  return _react2.default.createElement(
    'svg',
    { width: '12', height: '14' },
    _react2.default.createElement('circle', { cx: '7', cy: '7', r: '4', stroke: color, fill: color })
  );
};

var lineRenderer = function lineRenderer(_ref2) {
  var color = _ref2.color;
  return _react2.default.createElement(
    'svg',
    { width: '12', height: '14' },
    _react2.default.createElement('line', { x1: '0', y1: '7', x2: '11', y2: '7', stroke: color, strokeWidth: '2' })
  );
};

var FocusLegend = function FocusLegend(_ref3) {
  var data = _ref3.data,
      options = _ref3.options,
      type = _ref3.type,
      width = _ref3.width;

  if (width < REDUCED_THRESHOLD) {
    return null;
  }

  var itemRenderer = R.pipe(R.when(R.always(type === _constants.SCATTER), R.always(scatterRenderer)), R.when(R.always(type === _constants.TIMELINE), R.always(lineRenderer)))(null);

  var getItemLabel = R.ifElse(R.equals(_constants.SCATTER), R.always(R.pipe(R.prop('label'), R.split(' - '), R.last)), R.always(R.prop('label')))(type);

  var items = R.pipe(R.pathOr({}, ['share', 'focused']), R.mapObjIndexed(function (selection, key) {
    if (R.isNil(selection)) {
      return null;
    }
    var colors = R.pathOr([], ['serie', key + 'Colors'], options);
    var nColors = R.length(colors);
    return R.pipe(R.addIndex(R.map)(function (entry, index) {
      if (entry.value === 'uniq-dp') {
        return null;
      }
      var color = R.nth(index % nColors, colors);
      return { color: color, label: getItemLabel(entry) };
    }), R.filter(R.identity))(selection);
  }), R.props(['baseline', 'highlight']), R.filter(R.identity), R.unnest)(data);

  return _react2.default.createElement(_Legend2.default, { items: items, itemRenderer: itemRenderer });
};

FocusLegend.propTypes = {
  data: _propTypes2.default.object,
  options: _propTypes2.default.object,
  type: _propTypes2.default.string,
  width: _propTypes2.default.number
};

exports.default = FocusLegend;